import { DocumentNode, gql } from '@apollo/client';

export const TableauUserFragmentGql: DocumentNode = gql`
fragment TableauUser on TableauUser {
  username
  name
  domain
}
`;
